class AsideMenu {
  constructor() {
    this.asideMenu = document.querySelector(".aside-menu");
    this.menuToggle = document.getElementById("menuToggle");
    this.closeBtn = document.getElementById("closeBtn");
    this.isDesktop = window.innerWidth >= 750;
    this.isHoverEnabled = false;
    this.hoverTimeout = null;

    // --- Scroll lock state ---
    this._scrollY = 0; // guardará la posición antes de bloquear
    this._isScrollLocked = false;

    this.init();
    
    // Manejar redimensionamiento de ventana
    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 750;
    });
  }

  init() {
    this.toggleMenu();
    this.handleSubmenus();
    if (this.isDesktop) {
      this.setupHoverForDesktop();
    }

    // Observador para bloquear/desbloquear scroll cuando cambie el atributo [active]
    this.observeActiveAttribute();
  }

  lockScroll() {
    if (this._isScrollLocked) return;
    this._scrollY = window.scrollY || window.pageYOffset || 0;
    // Aplicar bloqueo preservando la posición
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    // (opcional) evitar que elementos internos cambien layout
    document.documentElement.classList.add('aside-menu-open');
    this._isScrollLocked = true;
  }

  unlockScroll() {
    if (!this._isScrollLocked) return;
    // Restaurar estilos
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.documentElement.classList.remove('aside-menu-open');

    // Restaurar la posición de scroll original
    window.scrollTo(0, this._scrollY || 0);
    this._scrollY = 0;
    this._isScrollLocked = false;
  }

  // Observa cambios en el atributo 'active' para bloquear / desbloquear automáticamente
  observeActiveAttribute() {
    if (!this.asideMenu) return;
    const obs = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === 'attributes' && m.attributeName === 'active') {
          if (this.asideMenu.hasAttribute('active')) {
            // Cuando el menú se abre
            this.lockScroll();
          } else {
            // Cuando el menú se cierra
            this.unlockScroll();
          }
        }
      });
    });
    obs.observe(this.asideMenu, { attributes: true });
    // Nota: no guardamos obs para desconectar porque el menú vive mientras la página viva.
  }

  setupHoverForDesktop() {
    if (!this.menuToggle || !this.asideMenu) return;
    
    // Abrir menú al hacer hover en el botón
    this.menuToggle.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverTimeout);
      this.isHoverEnabled = true;
      this.asideMenu.setAttribute('active', '');
    });

    // Cerrar menú al salir del botón, pero solo si no estamos sobre el menú
    this.menuToggle.addEventListener('mouseleave', (e) => {
      // Dar un pequeño delay para permitir la transición al menú
      this.hoverTimeout = setTimeout(() => {
        if (!this.isCursorOverMenu()) {
          this.asideMenu.removeAttribute('active');
          this.isHoverEnabled = false;
          
          // Cerrar también todos los submenús
          const submenus = this.asideMenu?.querySelectorAll(".submenu");
          submenus?.forEach((submenu) => {
            submenu.removeAttribute("active");
          });
          const allButtons = this.asideMenu?.querySelectorAll(".submenu-button");
          allButtons?.forEach((btn) => btn.classList.remove("active"));
        }
      }, 100);
    });

    // Mantener menú abierto cuando el cursor está sobre él
    this.asideMenu.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverTimeout);
      this.isHoverEnabled = true;
    });

    // Cerrar menú al salir del menú, pero solo si no estamos sobre el botón
    this.asideMenu.addEventListener('mouseleave', (e) => {
      this.hoverTimeout = setTimeout(() => {
        if (!this.isCursorOverButton()) {
          this.asideMenu.removeAttribute('active');
          this.isHoverEnabled = false;
          
          // Cerrar también todos los submenús
          const submenus = this.asideMenu?.querySelectorAll(".submenu");
          submenus?.forEach((submenu) => {
            submenu.removeAttribute("active");
          });
          const allButtons = this.asideMenu?.querySelectorAll(".submenu-button");
          allButtons?.forEach((btn) => btn.classList.remove("active"));
        }
      }, 100);
    });

    // Para submenús: mantenerlos abiertos cuando el cursor está sobre ellos
    const submenus = this.asideMenu?.querySelectorAll(".submenu");
    submenus?.forEach((submenu) => {
      submenu.addEventListener('mouseenter', () => {
        clearTimeout(this.hoverTimeout);
      });
      
      submenu.addEventListener('mouseleave', (e) => {
        // Solo manejamos el cierre de submenús a través de su propio timeout
        // Esto lo maneja handleSubmenus()
      });
    });
  }

  // Verificar si el cursor está sobre el menú
  isCursorOverMenu() {
    return this.asideMenu?.matches(':hover') || 
           document.querySelector('.submenu[active]')?.matches(':hover');
  }

  // Verificar si el cursor está sobre el botón
  isCursorOverButton() {
    return this.menuToggle?.matches(':hover');
  }

  toggleMenu() {
    // Para móvil: mantener el comportamiento de clic
    this.menuToggle?.addEventListener("click", (e) => {
      // En desktop, prevenir el clic si estamos usando hover
      if (this.isDesktop && this.isHoverEnabled) {
        e.preventDefault();
        return;
      }
      this.asideMenu?.toggleAttribute("active");
    });

    this.closeBtn?.addEventListener("click", () => {
      this.asideMenu?.removeAttribute("active");
      // Desactivar hover después de cerrar con botón
      this.isHoverEnabled = false;
    });

    window.addEventListener("click", (event) => {
      if (!this.isDesktop || !this.isHoverEnabled) {
        const target = event.target;
        if (target instanceof Element) {
          if (!target.closest(".aside-menu") && !target.closest("#menuToggle")) {
            this.asideMenu?.removeAttribute("active");
            const submenus = this.asideMenu?.querySelectorAll(".submenu");
            submenus?.forEach((submenu) => {
              submenu.removeAttribute("active");
            });
            const allButtons = this.asideMenu?.querySelectorAll(".submenu-button");
            allButtons?.forEach((btn) => btn.classList.remove("active"));
          }
        }
      }
    });
  }

  handleSubmenus() {
    const toggleSubmenus = this.asideMenu?.querySelectorAll(".submenu-button");

    toggleSubmenus?.forEach((button) => {
      // Para desktop: agregar hover a submenús
      if (this.isDesktop) {
        button.addEventListener('mouseenter', () => {
          clearTimeout(this.hoverTimeout);
          const submenuId = button.getAttribute("data-submenu-trigger");
          if (submenuId) {
            this.openSubmenu(submenuId, button);
          }
        });

        // Cerrar submenú al salir (con delay para transición suave)
        let submenuTimeout;
        button.addEventListener('mouseleave', () => {
          submenuTimeout = setTimeout(() => {
            const submenuId = button.getAttribute("data-submenu-trigger");
            if (submenuId) {
              const targetSubmenu = this.asideMenu?.querySelector(
                `[data-submenu-id="${submenuId}"]`,
              );
              if (targetSubmenu && !targetSubmenu.matches(':hover')) {
                targetSubmenu.removeAttribute("active");
                button.classList.remove("active");
                
                // Cerrar también submenús hijos
                const childSubmenus = targetSubmenu.querySelectorAll(".submenu");
                childSubmenus.forEach((child) => child.removeAttribute("active"));
                const childButtons = targetSubmenu.querySelectorAll(".submenu-button");
                childButtons.forEach((btn) => btn.classList.remove("active"));
              }
            }
          }, 150);
        });

        // Prevenir cierre si el ratón entra al submenú
        button.parentElement.addEventListener('mouseenter', () => {
          clearTimeout(submenuTimeout);
        });
      }

      // Para móvil: mantener clic
      button.addEventListener("click", (e) => {
        if (this.isDesktop && this.isHoverEnabled) {
          e.preventDefault();
          return;
        }
        const submenuId = button.getAttribute("data-submenu-trigger");
        if (submenuId) {
          this.toggleSubmenu(submenuId, button);
        }
      });
    });

    // Agregar eventos a los submenús para mantenerlos abiertos
    const submenus = this.asideMenu?.querySelectorAll(".submenu");
    submenus?.forEach((submenu) => {
      if (this.isDesktop) {
        submenu.addEventListener('mouseenter', () => {
          clearTimeout(this.hoverTimeout);
        });

        submenu.addEventListener('mouseleave', (e) => {
          const submenuId = submenu.getAttribute('data-submenu-id');
          const timeout = setTimeout(() => {
            // Verificar si el cursor no está en ningún botón de submenú relacionado
            const triggerButton = this.asideMenu?.querySelector(
              `[data-submenu-trigger="${submenuId}"]`
            );
            
            if (!submenu.matches(':hover') && 
                !triggerButton?.matches(':hover') &&
                !triggerButton?.closest('.submenu[active]')?.matches(':hover')) {
              submenu.removeAttribute("active");
              triggerButton?.classList.remove("active");
            }
          }, 150);
          
          // Guardar el timeout para poder limpiarlo
          submenu.dataset.leaveTimeout = timeout;
        });
        
        // Limpiar timeout cuando el cursor vuelve a entrar
        submenu.addEventListener('mouseenter', () => {
          if (submenu.dataset.leaveTimeout) {
            clearTimeout(parseInt(submenu.dataset.leaveTimeout));
          }
        });
      }
    });
  }

  openSubmenu(submenuId, button) {
    const targetSubmenu = this.asideMenu?.querySelector(
      `[data-submenu-id="${submenuId}"]`,
    );

    if (targetSubmenu) {
      // Cerrar otros submenús del mismo nivel
      const parentAside = targetSubmenu.parentElement;
      const siblingSubmenus = parentAside?.querySelectorAll(`:scope > .submenu`);

      siblingSubmenus?.forEach((submenu) => {
        if (submenu !== targetSubmenu) {
          submenu.removeAttribute("active");
        }
      });

      // Cerrar botones de otros submenús
      const parentNav = button.closest("nav");
      const siblingButtons = parentNav?.querySelectorAll(".submenu-button");
      siblingButtons?.forEach((btn) => {
        if (btn !== button) {
          btn.classList.remove("active");
        }
      });

      // Abrir el submenú actual
      targetSubmenu.setAttribute("active", "");
      button.classList.add("active");
    }
  }

  toggleSubmenu(submenuId, button) {
    const targetSubmenu = this.asideMenu?.querySelector(
      `[data-submenu-id="${submenuId}"]`,
    );

    if (targetSubmenu) {
      const isOpening = !targetSubmenu.hasAttribute("active");
      const parentAside = targetSubmenu.parentElement;
      const siblingSubmenus = parentAside?.querySelectorAll(`:scope > .submenu`);

      const parentNav = button.closest("nav");
      const siblingButtons = parentNav?.querySelectorAll(".submenu-button");
      siblingButtons?.forEach((btn) => {
        if (btn !== button) {
          btn.classList.remove("active");
        }
      });

      siblingSubmenus?.forEach((submenu) => {
        if (submenu !== targetSubmenu) {
          submenu.removeAttribute("active");

          const childSubmenus = submenu.querySelectorAll(".submenu");
          childSubmenus.forEach((child) =>
            child.removeAttribute("active"),
          );
          const childButtons = submenu.querySelectorAll(".submenu-button");
          childButtons.forEach((btn) => btn.classList.remove("active"));
        }
      });

      targetSubmenu.toggleAttribute("active");

      if (isOpening) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
        const childButtons = targetSubmenu.querySelectorAll(".submenu-button");
        childButtons.forEach((btn) => btn.classList.remove("active"));
      }
    }
  }
}

new AsideMenu();